import fetch from '../../../../utils/fetch'
import Vue from 'vue'

const getInitialState = () => {
  return {
    isLoading: false,
    emailChangeType: null,
    emailChangeStatus: false,
    error: null,
  }
}

const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  emailChangeType(state) {
    return state.emailChangeType
  },
  emailChangeStatus(state) {
    return state.emailChangeStatus
  },
  error(state) {
    return state.error
  },
}

const actions = {
  change({commit, dispatch, rootGetters}, jwt) {
    commit(types.RESET)
    commit(types.EMAIL_CHANGE_LOADING, true)
    try {

      let payload = Vue.$jwt.decode(jwt)

      // Token expiry is checked
      if ((new Date().getTime() / 1000) > payload.exp) {
        commit(types.EMAIL_CHANGE_ERROR, 'Invalid JWT (Expired)')
        return
      }

      // Token subject is checked
      if (payload.subject !== 'revert email' && payload.subject !== 'change email') {
        commit(types.EMAIL_CHANGE_ERROR, 'Invalid JWT (Subject)')
        return
      }

      commit(types.EMAIL_CHANGE_TYPE, payload.subject)

    } catch (e) {
      commit(types.EMAIL_CHANGE_ERROR, 'Invalid JWT')
      return
    }

    // Valid JWT
    return fetch(rootGetters['user/profile/iri'] + '/email/confirm', {
      method: 'PATCH',
      body: JSON.stringify({'token': jwt})
    })
      .then(response => response.json())
      .then((data) => {
        dispatch('user/profile/fetchSessionNoAvatar', null, {root: true})
        commit(types.EMAIL_CHANGE_STATUS, true)
      })
      .catch((error) => {
        commit(types.EMAIL_CHANGE_STATUS, false)
        commit(types.EMAIL_CHANGE_ERROR, error)
      })
  },

  reset({commit}) {
    commit(types.RESET)
  }
}

const types = {
  EMAIL_CHANGE_LOADING: 'EMAIL_CHANGE_LOADING',
  EMAIL_CHANGE_TYPE: 'EMAIL_CHANGE_TYPE',
  EMAIL_CHANGE_STATUS: 'EMAIL_CHANGE_STATUS',
  EMAIL_CHANGE_ERROR: 'EMAIL_CHANGE_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.EMAIL_CHANGE_LOADING](state, value) {
    state.isLoading = value;
  },
  [types.EMAIL_CHANGE_TYPE](state, type) {
    state.emailChangeType = type
  },
  [types.EMAIL_CHANGE_STATUS](state, status) {
    state.emailChangeStatus = status
  },
  [types.EMAIL_CHANGE_ERROR](state, error) {
    state.error = error;
    state.isLoading = false
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
